var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightWithCircleBorderWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeWidth: 1.66,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 1.77c5.098 0 9.231 4.133 9.231 9.23s-4.133 9.23-9.23 9.23a9.231 9.231 0 0 1 0-18.46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.114 8.317-4.469 5.959a1.155 1.155 0 0 1-1.738.124l-2.308-2.307"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightWithCircleBorderWhite);
export default __webpack_public_path__ + "static/media/right-with-circle-border-white.c40aefbae0ac96912bc09d1c503aa81f.svg";
export { ForwardRef as ReactComponent };